// GET_CURRENCY
export const GET_SETTINGS = "GET_SETTINGS";
export const GET_SETTINGS_FAIL = "GET_SETTINGS_FAIL";
export const GET_SETTINGS_SUCCESS = "GET_SETTINGS_SUCCESS";

export const GET_FAQS = "GET_FAQS";
export const GET_FAQS_FAIL = "GET_FAQS_FAIL";
export const GET_FAQS_SUCCESS = "GET_FAQS_SUCCESS";

